import { addElementEvents, removeElementEvents } from "../utils/events";
import { hasClass, addClass } from "../utils/dom";

const initFeaturesGallery = element => {
  const a = element.querySelectorAll("a");
  if (a.length === 1) {
    let href = a[0].getAttribute("href");
    let newA = document.createElement("a");
    newA.setAttribute("href", href);
    newA.innerHTML = element.innerHTML;
    newA.className = "wp-block-column-anchor";
    element.innerHTML = "";
    element.appendChild(newA);
  }
};

const initFeaturesGalleries = () => {
  const elements = document.querySelectorAll(
    ".ptw-featuresgallery .wp-block-column"
  );
  if (elements) {
    Array.prototype.forEach.call(elements, element => {
      initFeaturesGallery(element);
    });
  }
};

export default initFeaturesGalleries;
